<template>
  <header class="header">
    <div class="header__top-wrapper">
      <div class="container">
        <div class="header__top-content">
          <div class="header__logotype">
            <T1Logotype />
          </div>
          <div class="header__section">
            <T1HeaderContact />
            <template v-if="windowWidth < 992">
              <T1NavigationMobile />
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="header__navbar" v-if="windowWidth >= 992">
      <div class="container">
        <T1NavigationDesktop />
      </div>
    </div>
    <T1CovidHeaderInfo />
  </header>
</template>

<script>
import T1Logotype from "./T1Logotype";
import T1HeaderContact from "./T1HeaderContact";
import T1NavigationMobile from "./T1NavigationMobile";
import T1NavigationDesktop from "./T1NavigationDesktop";
import T1CovidHeaderInfo from "../T1Assets/T1CovidHeaderInfo";

export default {
  name: "page-header",
  data: () => ({
    windowWidth: 0,
  }),
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
  },
  created() {
    window.addEventListener("resize", this.handleResize, { passive: true });
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  components: {
    T1Logotype,
    T1HeaderContact,
    T1NavigationMobile,
    T1NavigationDesktop,
    T1CovidHeaderInfo,
  },
};
</script>

<style lang="scss" scoped>
.header {
  margin-bottom: 12px;

  &__top-wrapper {
    @media (max-width: $screen-sm-max) {
      background-color: $blue-dark;
      color: #fff;
    }
  }

  &__top-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 66px;

    @media (min-width: $screen-md) {
      height: 74px;
    }
  }

  &__section {
    display: flex;
    align-items: center;
  }

  &__navbar {
    background-color: $blue-dark;
    position: relative;
  }
}
</style>
